import { render, staticRenderFns } from "./TransportEditDialog.vue?vue&type=template&id=42f2b1d4&scoped=true"
import script from "./TransportEditDialog.vue?vue&type=script&lang=js"
export * from "./TransportEditDialog.vue?vue&type=script&lang=js"
import style0 from "./TransportEditDialog.vue?vue&type=style&index=0&id=42f2b1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2b1d4",
  null
  
)

export default component.exports